module.exports = __webpack_public_path__ + "assets/adobe-target.afbde1db.svg";